import { makeStyles } from "tss-react/mui";
import { Grid, Typography, Button } from "@mui/material";
import ResponsivePage from "./ResponsivePage";
import { useDevice } from "../../../providers/DeviceProvider";
import { GlobalStyles } from "tss-react";
import config from "../../../config";

const useStyles = makeStyles()(
  (theme) => ({
    slimHeader: {
      width: "100%",
      height: "auto",
      padding: theme.spacing(2),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(1),
      background: theme.palette.background.default,
      transition: "box-shadow 0.25s",
    },
    hugeButton: {
      height: "56px"
    }
  })
);

const SnackbarOverride = {
  body: {
    ".notistack-SnackbarContainer": {
      bottom: "92px"
    }
  }
};

export default function ResponsiveSubPage(props) {
  const { maxWidth, title, referenceTag, caption, backButton, backPath, primaryAction, secondaryAction, onPrimaryAction, onSecondaryAction, secondaryActionComponent, secondaryActionIcon, menuItems, stateTag, stateTagColor, widget, secondaryActionDisabled, primaryActionDisabled } = props;
  const { classes } = useStyles();
  const { slim } = useDevice();
  const buttonSizeXS = !!primaryAction && !!secondaryAction ? 6 : 12;

  const showFooter = slim && (!!primaryAction || !!secondaryAction);


  // the logic happening here can be done in responsivepage. TODO!
  return (
    <ResponsivePage
      showTitleWhenScrolled
      maxWidth={maxWidth || config.pageSize.full}
      widget={widget}
      stateTag={stateTag}
      stateTagColor={stateTagColor}
      backButton={backButton}
      referenceTag={referenceTag}
      backPath={backPath}
      title={title}
      safeTitle={title}
      caption={caption}
      primaryAction={!slim ? primaryAction : undefined}
      secondaryAction={!slim ? secondaryAction : undefined}
      onPrimaryAction={!slim ? onPrimaryAction : undefined}
      onSecondaryAction={!slim ? onSecondaryAction : undefined}
      secondaryActionDisabled={secondaryActionDisabled}
      primaryActionDisabled={primaryActionDisabled}
      secondaryActionIcon={secondaryActionIcon}
      secondaryActionComponent={secondaryActionComponent}
      menuItems={menuItems}
      footerWidget={
        showFooter ? (
          <>
            <GlobalStyles
              styles={SnackbarOverride}
            />

            <Grid container spacing={1}>

              {!!primaryAction ? (
                <Grid item xs={buttonSizeXS}>
                  <Button size="large" variant="outlined" fullWidth onClick={onPrimaryAction} className={classes.hugeButton} disabled={primaryActionDisabled}>
                    {primaryAction}
                  </Button>
                </Grid>
              ) : null}

              {!!secondaryAction ? (
                <Grid item xs={buttonSizeXS}>
                  <Button size="large" variant="contained" fullWidth onClick={onSecondaryAction} component={secondaryActionComponent} startIcon={secondaryActionIcon} className={classes.hugeButton} disabled={secondaryActionDisabled}>
                    {secondaryAction}
                  </Button>
                </Grid>
              ) : null}

            </Grid>
          </>
        ) : undefined
      }
    >

      {
        slim ? (
          <div className={classes.slimHeader}>
            <Typography variant="h4">{title}</Typography>
          </div>
        ) : undefined
      }

      {props.children}
    </ResponsivePage>
  );
}
